import { Flex, Menu, MenuProps } from "antd";
import { FC } from "react";
import { Link, useLocation } from "react-router";

import { Logo } from "@/components/Logo";

import BookIcon from "@/assets/book.svg?react";
import NewsIcon from "@/assets/news.svg?react";
import PieChartIcon from "@/assets/pie_chart.svg?react";

const navigationItems: MenuProps["items"] = [
  {
    key: "my-dashboard",
    icon: <PieChartIcon />,
    label: <Link to={"dashboard"}>Dashboard</Link>,
  },
  {
    key: "my-learning",
    icon: <BookIcon />,
    label: <Link to={"my-learning"}>My Learning</Link>,
  },
  {
    key: "post-feed",
    icon: <NewsIcon />,
    label: <Link to={"post-feed"}>Post Feed</Link>,
  },
];

export const Sider: FC = () => {
  const { pathname } = useLocation();
  const currLocation = pathname.split("/").pop();

  return (
    <Flex rootClassName="sider-container" vertical align="center" gap={"60px"}>
      <Logo type="customer" className="sider-logo" />
      <Flex rootClassName="navigation-menu-container" vertical>
        <Menu rootClassName="navigation-menu" items={navigationItems} defaultSelectedKeys={currLocation ? [currLocation] : undefined} />
      </Flex>
    </Flex>
  );
};
